module.exports = __webpack_public_path__ + "static/line-coupon-2c44ddf9cb2fba85d2dd4735f9d8fc2a.jpg";